import baseApi from './RootBaseApi';
import {
  GetActivePspFeeConfigParams,
  GetActivePspFeeConfigResponse,
  PspFeeConfig,
  UpdateActivePspFeeConfigPayload,
} from '@/types/psp-fee-config.types';

export const PspFeeConfigService = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getActivePspFeeConfig: builder.query<
      PspFeeConfig,
      GetActivePspFeeConfigParams
    >({
      query: (params) => ({
        url: '/psp-fee-configs/active',
        method: 'GET',
        params,
      }),
      transformResponse: (response: GetActivePspFeeConfigResponse) =>
        response.data,
      providesTags: (result, error, params) => [
        { type: 'PspFeeConfigs', id: params.provider },
      ],
    }),

    updateActivePspFeeConfig: builder.mutation<
      PspFeeConfig,
      UpdateActivePspFeeConfigPayload
    >({
      query: (payload) => ({
        url: '/psp-fee-configs/active',
        method: 'PUT',
        data: payload,
      }),
      invalidatesTags: (result, error, payload) => [
        { type: 'PspFeeConfigs', id: payload.provider },
      ],
    }),
  }),
});

export const {
  useGetActivePspFeeConfigQuery,
  useUpdateActivePspFeeConfigMutation,
} = PspFeeConfigService;
